<nav aria-label="breadcrumb">
  <ol class="breadcrumb mb-0">
    @for (
      crumb of breadCrumb;
      track $index;
      let last = $last;
      let home = $first;
      let index = $index
    ) {
      <li class="breadcrumb-item">
        @if (home) {
          <span
            (click)="backRoute()"
            style="cursor: pointer"
            role="button"
            tabindex="0"
            (keydown.enter)="
              $event.target === $event.currentTarget &&
                $any($event.currentTarget).click()
            "
            (keydown.space)="
              $event.target === $event.currentTarget && $event.preventDefault();
              $event.target === $event.currentTarget &&
                $any($event.currentTarget).click()
            "
            >{{ crumb }}</span
          >
        }

        @if (!last && !home) {
          <!-- Clients crumb - special navigation -->
          @if (crumb === 'Clients') {
            <a
              (click)="navigateToClients()"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Create UCC client name crumb - clickable navigation based on source -->
          @if (isCreateUccClientName(crumb)) {
            <a
              (click)="navigateClientNameFromCreateUcc()"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Transactions crumb - non-clickable on transaction pages -->
          @if (crumb === 'Transactions' && isOnTransactionPage()) {
            <span>{{ crumb }}</span>
          }

          <!-- Details and Edit Client crumbs - non-clickable when on edit-client-details page -->
          @if (
            (crumb === 'Details' || crumb === 'Edit Client') &&
            currentUrl.includes('/client/edit-client-details')
          ) {
            <span>{{ crumb }}</span>
          }

          <!-- Details and Complete Profile crumbs - non-clickable when on client-onboarding complete mode -->
          @if (
            (crumb === 'Details' || crumb === 'Complete Profile') &&
            currentUrl.includes('/client/client-onboarding') &&
            currentUrl.includes('mode=complete')
          ) {
            <span>{{ crumb }}</span>
          }

          <!-- Normal crumbs -->
          @if (
            crumb !== 'Clients' &&
            crumb !== 'Transactions' &&
            crumb !== 'Details' &&
            crumb !== 'Edit Client' &&
            crumb !== 'Complete Profile' &&
            !getBreadcrumbUrl(crumb) &&
            crumb !== clientNameFromQuery &&
            !isTransactionClientName(crumb) &&
            !isCreateUccClientName(crumb)
          ) {
            <a
              [routerLink]="['../', crumb.toLowerCase()]"
              queryParamsHandling="merge"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Breadcrumbs with specific navigation URLs (exclude Details, Edit Client, and Transactions on relevant pages) -->
          @if (
            getBreadcrumbUrl(crumb) &&
            crumb !== 'Transactions' &&
            crumb !== clientNameFromQuery &&
            !isTransactionClientName(crumb) &&
            !isCreateUccClientName(crumb) &&
            !(
              currentUrl.includes('/client/edit-client-details') &&
              (crumb === 'Details' || crumb === 'Edit Client')
            ) &&
            !(
              currentUrl.includes('/client/client-onboarding') &&
              currentUrl.includes('mode=complete') &&
              (crumb === 'Details' || crumb === 'Complete Profile')
            )
          ) {
            <a
              (click)="navigateToBreadcrumb(crumb)"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Client Name crumb from transaction - clickable to go back to holdings -->
          @if (isTransactionClientName(crumb) && crumb) {
            <a
              (click)="navigateToHoldings()"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Client Name crumb - when it's not the last item, make it clickable to go back to Details -->
          @if (
            crumb === clientNameFromQuery &&
            clientNameFromQuery &&
            !isTransactionClientName(crumb) &&
            !isCreateUccClientName(crumb)
          ) {
            <a
              (click)="goBackFromDetails()"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Scheme Name crumb - when it's not the last item, make it clickable -->
          @if (crumb === schemeDetailsName && schemeDetailsName) {
            <a
              (click)="goBackFromDetails()"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }
        }

        <!-- Last breadcrumb item - special handling for client name to make it clickable -->
        @if (last) {
          <!-- Transaction Client Name as last item - make it clickable to go back to holdings -->
          @if (isTransactionClientName(crumb) && crumb) {
            <a
              (click)="navigateToHoldings()"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Client Name as last item - make it clickable to go back -->
          @if (
            crumb === clientNameFromQuery &&
            clientNameFromQuery &&
            !isTransactionClientName(crumb) &&
            !isCreateUccClientName(crumb)
          ) {
            <a
              (click)="goBackFromDetails()"
              style="cursor: pointer"
              class="crumb-class"
            >
              {{ crumb }}
            </a>
          }

          <!-- Scheme Name as last item - display as text -->
          @if (crumb === schemeDetailsName && schemeDetailsName) {
            <span>{{ crumb }}</span>
          }

          <!-- All other last items remain as plain text (exclude transaction client names) -->
          @if (
            crumb !== clientNameFromQuery &&
            crumb !== schemeDetailsName &&
            !isTransactionClientName(crumb)
          ) {
            <span>{{ crumb }}</span>
          }
        }
      </li>
    }
  </ol>
</nav>
